import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { connect } from "react-redux";
import { getAllCategories } from "../../../actions/categoryActions";

import "./newmenustyle.css";

function CategoryMenu(props) {
  const { t, i18n } = useTranslation();

  let categories = props.categories;

  function onShowMenu(e) {
    if (
      !document
        .querySelector(".category-dropdown.is-on")
        .classList.contains("show")
    ) {
      document.querySelector(".category-dropdown.is-on").classList.add("show");
      document
        .querySelector(".category-dropdown.is-on > .dropdown-menu")
        .classList.add("show");
    } else {
      document
        .querySelector(".category-dropdown.is-on")
        .classList.remove("show");
      document
        .querySelector(".category-dropdown.is-on > .dropdown-menu")
        .classList.remove("show");
    }
    e.preventDefault();
  }

  return (
    <div className={`dropdown category-dropdown is-on`}>
      <Link
        to="#"
        className="dropdown-toggle"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        data-display="static"
        title="Browse Categories"
        onClick={onShowMenu}
      >
        {" "}
        {/* style={{'backgroundColor': '#f6830f'}} */}
        {/*Browse Categories*/}
        {/*<Trans i18nKey="categories">Browse Categories</Trans>*/}
        {/*t('categories')*/}
        Catégories
      </Link>

      <div className={`dropdown-menu`}>
        <nav className="side-nav">
          <ul
            className="menu-vertical sf-arrows sf-js-enabled main "
            style={{
              // overflowY: "scroll",
              maxHeight: "650px",
              direction: "rtl",
              scrollbarWidth: "thin !important",
            }}
          >
            {/* style={{ overflowY: 'scroll', maxHeight: '650px', direction: 'rtl', scrollbarWidth: 'thin !important' }} */}
            {categories.map((item) => (
              <li
                key={item.id}
                className="megamenu-container megamenu-container--main"
              >
                <Link
                  to={`${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${item.slug}`}
                  className="text-truncate"
                >
                  <i className="" key={`${item.id}`}></i>
                  {item.nameFr}
                </Link>
                {item.children.length > 0 && (
                  <div className="megamenu">
                    <div className="row no-gutters">
                      {}

                      <div className={`col-md-12`}>
                        <div className="menu-col">
                          <div className="card-columns">
                            {item.fileName && (
                              <div className="card border-0">
                                <div className="banner banner-overlay">
                                  <Link
                                    to={`${process.env.REACT_APP_API_URL}/uploads/categories/${item.fileName}`}
                                    className="banner banner-menu"
                                  >
                                    <img
                                      className="bg-white"
                                      src={`${process.env.REACT_APP_API_URL}/uploads/categories/${item.fileName}`}
                                      alt="Banner"
                                    />
                                  </Link>
                                </div>
                              </div>
                            )}

                            {item.children.map((ch) => (
                              <div key={ch.id} className={`card border-0`}>
                                <div className="menu-title">
                                  <Link
                                    to={`${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${ch.slug}`}
                                    className="text-truncate"
                                  >
                                    {ch.nameFr}
                                  </Link>
                                  {ch.children.length > 0 && (
                                    <ul>
                                      {ch.children.map((c) => (
                                        <li key={c.id}>
                                          <Link
                                            to={`${process.env.REACT_APP_PUBLIC_URL}/shop/bycategory/${c.slug}`}
                                            className=""
                                            style={{
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {c.nameFr}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories.categories ? state.categories.categories : [],
  };
};

export default connect(mapStateToProps, { getAllCategories })(
  React.memo(CategoryMenu)
);
//export default CategoryMenu;
